// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".material-design-icon{display:inline-flex;align-self:center;position:relative;height:1em;width:1em}.material-design-icon>.material-design-icon__svg{height:1em;width:1em;fill:currentColor;position:absolute;bottom:-.125em}", ""]);
// Exports
module.exports = exports;
